var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.loading)?_c(this.$route.meta.layout || 'div',{tag:"component"},[_c('router-view')],1):_c('div',[_c('div',{staticClass:"app-loader",attrs:{"id":"loader"}},[_c('span',{staticClass:"spinner"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }